import { useQueryNormalizer } from '@repo/react-query-cache';
import type { Data } from '@repo/react-query-cache/core';
import type { WithOnlyIdRequired } from '../../../lib/typescript';
import type { IWidget } from '../../types';
import { useUpdateBaseModel } from '../base';
import { WIDGETS_NAMESPACE } from './constants';

interface IUpdateWidgetParams {
	data: WithOnlyIdRequired<IWidget>;
	invalidateReport?: boolean;
	reportId?: string;
}

export function useUpdateWidget() {
	const queryNormalizer = useQueryNormalizer();

	return useUpdateBaseModel<IWidget, IUpdateWidgetParams>({
		namespace: WIDGETS_NAMESPACE,
		disableOptimisticUpdate: true,
		disableInvalidation: true,
		options: {
			onSuccess: (data, variables) => {
				// Normy merges old and new data, so deleting a filter will not remove it from the cache.
				// thus, we need to set removed filters to null rather than deleting them.
				const oldWidget = queryNormalizer.getObjectById(
					data.id
				) as unknown as IWidget;

				if (
					oldWidget?.metric_metadata?.user_filter &&
					data.metric_metadata?.user_filter
				) {
					const oldFilters = Object.keys(oldWidget.metric_metadata.user_filter);
					const newFilters = Object.keys(data.metric_metadata.user_filter);

					const removedFilters = oldFilters.filter(
						(key) => !newFilters.includes(key)
					);

					// Add removed filters and set them to null
					const updatedFilter = {
						...data.metric_metadata.user_filter,
						...Object.fromEntries(removedFilters.map((key) => [key, null])),
					};

					queryNormalizer.setNormalizedData({
						...data,
						metric_metadata: {
							...data.metric_metadata,
							user_filter: updatedFilter,
						},
					} as unknown as Data);
				}
			},
		},
	});
}
